import { useMutation, useQueryClient } from "react-query";

import { AxiosError } from "axios";

import { RunCrawlerRequest, RunCrawlerResponse } from "../types";
import { makeRequest } from "../../util";

async function runOneOffWebTrackerScan(
  data: RunCrawlerRequest
): Promise<RunCrawlerResponse> {
  const res = await makeRequest<RunCrawlerResponse>(
    "run_one_off_web_tracker_scan",
    data
  );

  return {
    scans: res.data.scans.map((scan) => {
      return {
        ...scan,
        startedAt: scan.startedAt ? new Date(scan.startedAt) : null,
        stoppedAt: scan.stoppedAt ? new Date(scan.stoppedAt) : null,
      };
    }),
  };
}

export default function useRunOneOffWebTrackerScan(
  onSuccess: () => void,
  onError: (errorMessage: string) => void
) {
  const queryClient = useQueryClient();

  return useMutation<
    RunCrawlerResponse,
    AxiosError<{ error_message: string }>,
    RunCrawlerRequest
  >(runOneOffWebTrackerScan, {
    onSuccess: () => {
      void queryClient.invalidateQueries("list-running-web-tracker-scans");

      onSuccess();
    },
    onError: (error) => {
      onError(
        error.response?.data.error_message ?? "Unknown error running scan"
      );
    },
  });
}
